import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import { fieldsCitas } from './fieldsCitas';


const getAll = async (params = {}) => {
  
  const query = `
    query qrallCitas(
      $estadoRevision : String,
      $pacienteId     : ID,
      $doctorId       : ID, 
      $nombre         : String, 
      $signosflag     : String, 
      $establecimiento: String, 
      $especialidad   : String,
      $estadoCita     : String,
      $fechaHoy       : Boolean,
      $fechaDesde     : String,
      $fechaHasta     : String, 
      $excel          : String, 
      $pdf            : String, 
      $mspFiltro      : Boolean, 
      $cobertura      : ID,
      $page           : Int, 
      $pageSize       : Int
      $observaciones  : String
    ) {
      allCitas(
        estadoRevision : $estadoRevision,
        pacienteId     : $pacienteId,
        doctorId       : $doctorId, 
        nombre         : $nombre, 
        signosflag     : $signosflag, 
        establecimiento: $establecimiento, 
        especialidad   : $especialidad, 
        estadoCita     : $estadoCita,
        fechaHoy       : $fechaHoy,
        fechaDesde     : $fechaDesde, 
        fechaHasta     : $fechaHasta, 
        excel          : $excel, 
        pdf            : $pdf,
        mspFiltro      : $mspFiltro, 
        cobertura      : $cobertura
        page           : $page,
        pageSize       : $pageSize,
        observaciones  : $observaciones
      ) {
        total
        status
        dataarchivo
        message
        cita {
          detallescitaSet {
            id
            detailsSeguro
            detallesTitulares
          }
          id
          token
          fechaCreacion
          consultacitamedicaSet {
            token
            fechaCreacion
            estado
            descansomedicoSet {
              id
            }
          }
        
          cobSeleccionada {
            descripcion
            id
          }
          fechaCita
          horaCita
          usuarioCreador{
            username
          }
          urlsMspPaciente
          urlsMspTitular1
          urlsMspTitular2
          urlsMspTitular3
          estado
          estadoSignosvital
          estadoRevision
          estadoActual
          establecimiento{
            id
            Descripcion
          }
          paciente{
            id
            numHistoriaClinica
            persona {
              primerNombre
              primerApellido
              identificacion
              fechaNacimiento
            }
          }
          doctor {
            id
            
            idPersona {
              primerNombre
              primerApellido
              identificacion
            }
            especialidad {
              descripcion
              codEsp
            }
          }
        }
      }
    }
  `;


  const variables = {
    ...params
  }

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.allCitas;
    if(response2.status !== 'success') return null;

    const data = response2.cita;

    return {
      data,
      total: response2.total
    };

  }catch(error){
    console.error('Error al obtener las citas', error);
    return null;
  }
}


const getByToken = async (tokenCita) => {

  if(!tokenCita) return null;

  const query = `
    query AllCitas($tokenCita:String) {
      allCitas(tokenCita: $tokenCita) {
        ${fieldsCitas}
        total
        status
        message
      }
    }
  `;

  const variables = {
    tokenCita
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.allCitas;
    if(response2.status !== 'success') return null;

    const data = response2.cita[0];
    return data;

  }catch(error){
    console.error('Error al obtener la cita por token', error);
    return null;
  }
}


const crearRegistro = async (params = {}) => {

  const query = `
    mutation crearCita (
      $paciente         : String!,
      $doctor           : String!,
      $estadoCita       : String!,
      $estadoActual     : String,

      $cobSeleccionada  : String,
      $derivacion       : Int!,


      $horaCita         : String!,
      $encuesta         : String!,
      $establecimiento  : String!,
      
      $tipoContingencia : ID!,
      $isInterconsulta  : String,
      $fechaIngreso     : String,

      $codderivacion    : String,
      $fecderivacion    : String,
      $fecfinderivacion : String,
      $segderivacion    : String,

      $urlDerivacion    : String,
      $urlCodigoDer     : String,
      $url007Recibido   : String,
      $urlMspPaciente   : String!,
      $urlMspTitular1   : String!,
      $urlMspTitular2   : String!,
      $urlMspTitular3   : String!,
      $urlSolImgDer     : String,
      $urlSolLabDer     : String,
      $urlSolProcDer    : String,

      $urlOtrosDocumentos : String,

      $tipoServicios    : String,
    ) {
      crearCita(
        paciente        : $paciente,
        estadoActual    : $estadoActual,
        doctor          : $doctor,
        estadoCita      : $estadoCita,
        
        cobSeleccionada : $cobSeleccionada,
        horaCita        : $horaCita,
        encuesta        : $encuesta,
        establecimiento : $establecimiento,
        
        derivacion      : $derivacion,
        
        tipoContingencia: $tipoContingencia,
        isInterconsulta : $isInterconsulta,
        segderivacion   : $segderivacion,
        fechaIngreso    : $fechaIngreso,

        codderivacion   : $codderivacion,
        fecderivacion   : $fecderivacion,
        fecfinderivacion: $fecfinderivacion,

        urlDerivacion   : $urlDerivacion,
        url007Recibido  : $url007Recibido,
        urlMspPaciente  : $urlMspPaciente,
        urlMspTitular1  : $urlMspTitular1,
        urlMspTitular2  : $urlMspTitular2,
        urlMspTitular3  : $urlMspTitular3,
        urlSolImgDer    : $urlSolImgDer,
        urlSolLabDer    : $urlSolLabDer,
        urlSolProcDer   : $urlSolProcDer,
        urlCodigoDer    : $urlCodigoDer,

        urlOtrosDocumentos: $urlOtrosDocumentos,
        tipoServicios     : $tipoServicios
      ) {
        cita {
          token,
          id,
        }
        status,
        message
      }
    } 
  `;

  const variables = {
    ...params
  }

  try{

    const response = await axios.post(rutas.axios + 'api', { query, variables });

    if (response.status !== 200) return null;

    const response2 = response.data.data.crearCita;
    if (response2.status !== "success") return null;

    const data = response2.cita;
    return data;

  }catch(error){
    console.error('Error al crear la cita', error);
    return null;
  }
}


const updateByToken = async (tokenCita, fields) => {

  if(!tokenCita) return null;

  const query = `
    mutation UpdateCita(
      $tokenCita         : String
      $paciente          : String
      $doctor            : String
      $horaCita          : String
      $fechaCita         : String
      $tipoContingencia  : String
      $tipoServicios     : String
      $estadoRevision    : String
      $urlMspPaciente    : String
      $urlMspTitular1    : String
      $urlMspTitular2    : String
      $urlMspTitular3    : String
      $estadoActual      : String
      $estadoCita        : String
      $cobSeleccionada   : String
      $derivacion        : Int
      $codderivacion     : String
      $fecderivacion     : String
      $fecfinderivacion  : String
      $segderivacion     : String
      $fechaIngreso      : String
      $encuesta          : String
      $establecimiento   : String
      $urlDerivacion     : String
      $urlCodigoDer      : String
      $url007Recibido    : String
      $urlSolImgDer      : String
      $urlSolLabDer      : String
      $urlSolProcDer     : String
      $urlOtrosDocumentos: String
    ) {
      updateCita(
        tokenCita         : $tokenCita,
        paciente          : $paciente
        doctor            : $doctor
        horaCita          : $horaCita
        fechaCita         : $fechaCita
        tipoContingencia  : $tipoContingencia
        tipoServicios     : $tipoServicios
        estadoRevision    : $estadoRevision
        urlMspPaciente    : $urlMspPaciente
        urlMspTitular1    : $urlMspTitular1
        urlMspTitular2    : $urlMspTitular2
        urlMspTitular3    : $urlMspTitular3
        estadoActual      : $estadoActual
        estadoCita        : $estadoCita
        cobSeleccionada   : $cobSeleccionada
        derivacion        : $derivacion
        codderivacion     : $codderivacion
        fecderivacion     : $fecderivacion
        fecfinderivacion  : $fecfinderivacion
        segderivacion     : $segderivacion
        fechaIngreso      : $fechaIngreso
        encuesta          : $encuesta
        establecimiento   : $establecimiento
        urlDerivacion     : $urlDerivacion
        urlCodigoDer      : $urlCodigoDer
        url007Recibido    : $url007Recibido
        urlSolImgDer      : $urlSolImgDer
        urlSolLabDer      : $urlSolLabDer
        urlSolProcDer     : $urlSolProcDer
        urlOtrosDocumentos: $urlOtrosDocumentos
      ) {
        cita {
          id
          token
        }
        status
        message
      }
    }
  `;

  const variables = {
    tokenCita,
    ...fields
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.updateCita;
    if(response2.status !== 'success') return null;
    
    const data = response2.cita;
    return data;
    
  }catch(error){
    console.error('Error al obtener la cita por token', error);
    return null;
  }
}


const guardarDetalles = async (dataDetalles) => {

  const query = `
    mutation crearCitaDetails (
      $cita        : ID!,
      $titulares   : String,
      $segurosCita : String
    ) {
      crearCitaDetails(
        cita        : $cita,
        titulares   : $titulares,
        segurosCita : $segurosCita
      ) {
        citaDetails {
          token,
          id              
        }
        status,
        message
      }
    }
  `;

  const variables = {
    ...dataDetalles
  };

  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });
    if (response.status !== 200) return null;

    const response2 = response.data.data.crearCitaDetails;
    if (response2.status !== "success") return null;

    const data = response2.citaDetails;
    return data;

  }catch(error){
    console.error('Error al obtener la cita por token', error);
    return null;
  }
}


const actualizarDetalles = async (dataDetalles) => {

  const query = `
    mutation editarCitaDetails (
      $idCitaDetails : ID!,
      $arrayUrls     : String,
      $titulares     : String,
      $segurosCita   : String
    ) {
      editarCitaDetails(
        idCitaDetails : $idCitaDetails,
        arrayUrls     : $arrayUrls,
        titulares     : $titulares,
        segurosCita   : $segurosCita
      ) {
        citaDetails {
          token,
          id
        }
        status,
        message
      }
    }
  `;

  try{
    const response = await axios.post(rutas.axios + "api", { query, variables: dataDetalles });
    if (response.status !== 200) return null;

    const response2 = response.data.data.editarCitaDetails;
    if (response2.status !== "success") return null;

    return response2.citaDetails;

  }catch(error){
    console.error('Error al actualizar los detalles de la cita', error);
    return null;
  }
}
  

const getAtencion = async (tokenCita) => {

  const query = `
    query AllCitas($tokenCita: String) {
      allCitas(tokenCita: $tokenCita) {
        cita {
          id
          token

          consultacitamedicaSet {
            id
            token
          }
            
        }
      }
    }
  `;

  const variables = {
    tokenCita
  };

  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });
    if (response.status !== 200) return null;

    const response2 = response.data.data.allCitas.cita[0];
    if (!response2) return null;

    const data = response2.consultacitamedicaSet;
    return data;
    
  }catch(error){
    console.error('Error al obtener la cita por token', error);
    return null;
  }
}

export const citasService = {
  crearRegistro,
  getAll,
  getByToken,
  updateByToken,
  guardarDetalles,
  actualizarDetalles,
  getAtencion
}
